import type { AiTable as AiTableData } from '@apis/aiAgent';
import { ForecastStrip } from '../MorningBrief/ForecastStrip';
import { AiTable } from './AiTable';
import type { IExportSelectionProps } from './ExportSelectable';

interface IAiTableDrawingProps extends IExportSelectionProps {
  table: AiTableData;
}

/**
 * A table an answer drew, in the face its rows call for: a forecast as the
 * brief's day cards, anything else as the grid. One place for the choice, so
 * the full page and the dashboard card cannot draw the same answer differently.
 */
export function AiTableDrawing({ table, ...selection }: IAiTableDrawingProps) {
  return table.view === 'forecast' ? (
    <ForecastStrip table={table} {...selection} />
  ) : (
    <AiTable table={table} {...selection} />
  );
}
